<template>
  <Popup :ref="(el) => popup = el"
         class="popup__lg"
         :title="$t('labels.message_logs', {'device_name': device?.name})"
         @onClose="hide"
  >
    <div class="details-filter">
      <div class="filters">
        <div class="form">
          <div class="form-block form-block--30">
            <DatePicker v-model="filters.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
              <template v-slot="{ inputValue, togglePopover, inputEvents }">
                <input
                  class="form-control form-control-sm"
                  :placeholder="$t('labels.from_date')"
                  :value="inputValue"
                  @focus="togglePopover"
                  @change="inputEvents.change"
                />
              </template>
            </DatePicker>
          </div>

          <div class="form-block form-block--30">
            <DatePicker v-model="filters.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
              <template v-slot="{ inputValue, togglePopover, inputEvents }">
                <input
                  class="form-control form-control-sm"
                  :placeholder="$t('labels.to_date')"
                  :value="inputValue"
                  @focus="togglePopover"
                  @change="inputEvents.change"
                />
              </template>
            </DatePicker>
          </div>

          <div class="form-block form-block--30">
            <LoaderButton :on-click="applyFilters" class="form__btn btn">
              <span class="text-capitalize-first">{{$t('button.apply')}}</span>
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>


    <LoaderContent ref="loader" class="" style="min-height: 500px">
      <div class="" v-if="device" >
        <div class="" style="overflow: auto">
          <table class="table table-striped" style="position: relative">
            <thead>
            <tr>
              <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.id_date') }}</span></th>
              <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.status') }}</span></th>
              <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.type') }}</span></th>
              <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.message') }}</span></th>
              <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.trade_deal') }}</span></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in paginatedResponse.items" :key="index" class="">
              <td class="p-sm">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center gap-sm">
                    <span v-b-tooltip.hover :title="item.log.message.id">{{ item.log.message.id.substring(0, 8) }}...</span> <copy-button :value="item.log.message.id"></copy-button>
                  </div>
                  <small class="text-secondary">{{ dateHelper.format(item.log.message.created_at) }}</small>
                </div>
              </td>
              <td  class="p-sm">
                {{ item.log.message.status }}
              </td>
              <td class="p-sm">
                <div class="d-flex flex-column">
                  <span>{{ $t(`message_log.type.${item.log.message.message_source.trigger}`) }} - {{ item.log.bank?.name }}</span>
                  <small v-if="item.log.message.user_agent" class="text-secondary">{{ parseUserAgent(item.log.message.user_agent) }}</small>
                </div>
              </td>
              <td  class="p-sm">
                <div v-if="item.log.message.message_source.trigger === 'app_push_notification'">
                  <strong>
                    {{ item.log.message.message_source.app_push_notification.title}}
                  </strong>
                  <br>
                  {{ item.log.message.message_source.app_push_notification.notification}}
                </div>
                <div v-else-if="item.log.message.message_source.trigger === 'sms'">
                  <strong>
                    {{ item.log.message.message_source.sms.number}}
                  </strong>
                  <br>
                  {{ item.log.message.message_source.sms.message}}
                </div>
                <div v-else>
                  {{ JSON.stringify(item.log.message.message_source)}}
                </div>
              </td>
              <td class="text-nowrap p-sm" >
                <div v-if="!item.notification">
                  n/a
                </div>
                <div v-else>
                  <div v-for="error in item.notification.errors" :key="error">
                    <span class="text-danger">{{ $t(`message_log.error.${error}`)}}</span>
                  </div>

                  <div v-if="item.notification.dealId">

                  <div class="d-flex align-items-center justify-content-between gap-sm">
                    <div class="d-flex align-items-center gap-xs">
                      <span>{{ item.notification.dealPublicId }}</span>
                      <copy-button :value="item.notification.dealPublicId"></copy-button>
                    </div>
                    <button @click.prevent="showDealDetails(item.notification.dealId)" type="button" @click="" class="btn btn-sm">
                      <svg-icon icon="details"></svg-icon>
                    </button>
                  </div>
                  </div>
                </div>

              </td>
            </tr>
            </tbody>
          </table>
          <b-pagination
            v-if="paginatedResponse.totalCount > paginatedResponse.items.length"
            v-model="page"
            :total-rows="paginatedResponse.totalCount"
            :per-page="paginatedResponse.limit"
            :limit="20"
            @update:modelValue="load()"
            :prev-text="$t('button.back')"
            :next-text="$t('button.next')"
            align="start"
            first-number
            hide-goto-end-buttons
            hide-ellipsis
          ></b-pagination>
        </div>
      </div>
    </LoaderContent>
    <DealDetailsPopup ref="dealDetailsPopup"></DealDetailsPopup>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import { useStore } from 'vuex';
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import { api } from '@/service/APIClient';
import {dateHelper} from "@/service/DateHelper";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {DatePicker} from "v-calendar";
import DealDetailsPopup from "@/apps/public/components/DealDetailsPopup.vue";
import SvgIcon from "@/apps/public/components/SvgIcon.vue";

export default defineComponent({
  methods: {$t},
  components: {
    SvgIcon,
    DealDetailsPopup,
    DatePicker, BPagination, LoaderContent, CopyButton, LoaderButton, FormInputWrapper, Popup},
  setup(props) {
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const dealDetailsPopup = ref<InstanceType<typeof DealDetailsPopup> | null>(null)
    const store = useStore()
    const state = reactive({
      device: null as TraderDeviceDTO|null,
      filters: {fromDate: null, toDate:null} as any,
      dealDetailsModal: false,
      page: 1,
      limit: 20,
      paginatedResponse: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<any>
    });

    const show = (device: TraderDeviceDTO, fromDate: string|null = null, toDate: string|null = null) => {
      state.filters =  {fromDate: fromDate, toDate: toDate}
      state.paginatedResponse = {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<any>
      state.page = 1;
      state.device = device
      popup.value?.show()
      load()
    }

    const hide = () => {
      popup.value?.hide()
    }

    const applyFilters = async () => {
      state.page = 1;
      await load()
    }


    const load = async () => {
      await loader.value?.load(_load)
    }

    const _load = async () => {
      if (!state.device) {
        return;
      }

      const offset = state.limit * (state.page - 1)
      state.paginatedResponse = await api.devicesMessageLogs(state.device.id, {
        limit: state.limit,
        offset: offset,
        fromDate: dateHelper.toUTC(state.filters.fromDate),
        toDate: dateHelper.toUTC(state.filters.toDate),
      });
    }

    const showDealDetails = async (dealId: string) => {
        dealDetailsPopup.value?.show(dealId)
    }

    const parseUserAgent = (ua: string) => {
      if (!ua) {
        return ua;
      }

      return ua.replace(/(^.)(.+)(\/.*)/, '$1$3');
    }

    return {
      ...toRefs(state),
      showDealDetails,
      applyFilters,
      parseUserAgent,
      loader,
      popup,
      helper,
      load,
      show,
      hide,
      dateHelper,
      dealDetailsPopup
    }
  }
})
</script>
